import { Auth0Provider, useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useLoaderData, useParams } from 'react-router-dom';
import { Nav } from '../../components/Nav';
import { AudioDataProvider } from '../../context/AudioDataContext';
import { RecordingContextProvider } from '../../context/RecordingContext';
import { useSearchParams } from 'react-router-dom';
import { useEventTracking } from '@services/statsig';
import { getPreviewAppState } from '@utils/getPreviewAppState';

export type UserDataType = any;

export const AuthenticationSignupWrapper = () => {
  // production
  const domain = 'smartscribehealth.us.auth0.com';
  const clientId = 'RG4FwiozZWwAAe83xQxv2metpgJaPe0j';
  const sharedCallback = import.meta.env.VITE_SHARED_AUTH_CALLBACK;
  const redirectUri = sharedCallback
    ? window.location.origin + sharedCallback
    : window.location.origin + '/callback';
  const audience = 'https://api.smartscribe.health';

  // development
  // const domain = "smartscribe-development.us.auth0.com";
  // const clientId = "ohWExKeDUG8L1LY5oRJXPseSfaqN1mid";
  // const redirectUri = window.location.origin + "/callback";
  // const audience = "https://api.smartscribe.health/development";

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience: audience,
        redirect_uri: redirectUri,
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      <AudioDataProvider>
        <RecordingContextProvider>
          <Nav />
          <UserSignUp />
        </RecordingContextProvider>
      </AudioDataProvider>
    </Auth0Provider>
  );
};

const UserSignUp = () => {
  const { loginWithRedirect } = useAuth0();
  const [searchParams] = useSearchParams();
  const { auth: authMetrics } = useEventTracking();
  const id = searchParams.get('signin');
  const invite_token = searchParams.get('invite_token');
  const referralCode = searchParams.get('ref');
  const email = searchParams.get('email');
  useEffect(() => {
    // Capture and store URL parameters
    const params = new URLSearchParams(window.location.search);
    const paramsObj: { [key: string]: string } = {};
    params.forEach((value: string, key: string) => {
      paramsObj[key] = value;
    });
    localStorage.setItem('urlParams', JSON.stringify(paramsObj));

    // Store Group Invite token in localStorage
    localStorage.setItem('invite_token', invite_token ? invite_token : '');

    // Store referral code in localStorage
    localStorage.setItem('referralCode', referralCode ? referralCode : '');
    
    // Track signup started event
    authMetrics.signupStarted({
      referral_code: referralCode || undefined,
      has_group_invite: !!invite_token,
      signin_param: !!id, // true if coming from signin link
      source: referralCode ? 'referral' : invite_token ? 'group_invite' : 'organic',
    });
    
    const sharedCallback = import.meta.env.VITE_SHARED_AUTH_CALLBACK;
    loginWithRedirect({
      appState: { ...getPreviewAppState() },
      authorizationParams: {
        screen_hint: id ? '' : 'signup',
        redirect_uri: sharedCallback
          ? window.location.origin + sharedCallback
          : window.location.origin + '/callback',
        login_hint: email || undefined,
      },
    });
  }, []);

  return <div className="max-w-screen-lg mx-auto">Redirecting...</div>;
};

export default UserSignUp;
